<template>
    <div>
        <span v-if="typeof robotItem.content ==='string'">
            <code-data :data="robotItem.content"/>
        </span>
        <div v-else-if="robotItem.stage === 'improve_prompt'">
            <code-data :data="robotItem.content.prompt"/>
        </div>
        <div v-else-if="robotItem.stage === 'workflow'">
            <a-divider>流程图</a-divider>
            <mermaid-component :data="robotItem.content.mermaid" :task="robotItem.task_id"></mermaid-component>
            <a-divider>Workflow</a-divider>
            <code-data :data="robotItem.content.workflow"/>
            <a-divider>建议使用的工具</a-divider>
            <div v-for="(tool, indexS) in robotItem.content.tools" :key="indexS">
                <h4>
                    {{indexS+1}}.{{tool.name}}:&nbsp;
                </h4>
                {{tool.suggestion}}
            </div>

        </div>
        <div v-else-if="robotItem.stage === 'tool_score'">
            <div v-for="(tool, indexS) in robotItem.content.tools" :key="indexS">
                <!--                <a-row>-->
                <!--                    <a-col span="8">-->
                <!--                        {{indexS+1}}.{{scoreK}}-->
                <!--                    </a-col>-->
                <!--                    <a-col span="15">-->
                <!--                        <a-rate v-model:value="robotItem.content[scoreK][0]" :count="10" disabled />-->
                <!--                        {{robotItem.content[scoreK][0]}}-->
                <!--                    </a-col>-->
                <!--                </a-row>-->
                <h3>
                    <span>{{indexS+1}}.{{tool.name}}</span>&nbsp;
                    <a-rate v-model:value="tool.score" :count="10" disabled />
                    {{tool.score}}
                </h3>
                <p>
                    <span>
                        {{tool.suggestion}}
                    </span>
                </p>
            </div>
        </div>
        <div v-else-if="robotItem.stage === 'code'">


            <a-tabs tab-position="right">
                <a-tab-pane key="0" tab="Codes">
                    <div v-for="(code, cK) in robotItem.content.total_result.code_info" :key="cK">
                        <code-info :data="code"></code-info>
                    </div>
                </a-tab-pane>
                <a-tab-pane key="2" tab="Partial result">
                    <div v-for="(rp, rpI) in robotItem.content.partial_result" :key="rpI">
                        <h3>Code {{rp.action + 1}} <span :style="{color:rp.finish? '#75BD42': '#E54C5E'}">
                            {{rp.finish? '运行结束': '运行失败'}}
                        </span>

                        </h3>
                        <p>
                            <a-space>
                                <b>中间文件：</b>
                                <a v-for="(file_name, fK) in rp.files" :key="fK" @click="downFile(file_name, rp.path)">
                                    {{file_name}}<span v-if="fK < rp.files.length - 1">, </span>
                                </a>
                            </a-space>
                        </p>

                        <code-data :data="'```' + rp.code +'```'"></code-data>
                    </div>
                </a-tab-pane>

                <a-tab-pane key="1" tab="Files">
                    <file-list :root="robotItem.content.total_result.path" :downable="true"/>
                </a-tab-pane>
            </a-tabs>
        </div>
        <div v-else-if="robotItem.stage === 'summary'">
            <code-data :data="robotItem.content.summary"></code-data>
        </div>
    </div>
</template>

<script>
    import {
        // CodeOutlined,
    } from '@ant-design/icons-vue';
    import CodeData from "../components/CodeData";
    import CodeInfo from './CodeInfo';
    import MermaidComponent from "./MermaidComponent";
    import FileList from "./FileList";
    import {down_file} from "../utils/request";
    export default {
        name: "RobotDetail",
        props: ['data'],
        components: {
            // 'code-outlined': CodeOutlined,
            'code-data': CodeData,
            'code-info': CodeInfo,
            'mermaid-component': MermaidComponent,
            'file-list': FileList,
        },
        data (){
            return {
                robotItem: this.data,
            }
        },
        methods: {
            showToolDetail(scoreK){
                let {robotItem} = this;
                let {content} = robotItem;
                content[scoreK][3] = !content[scoreK][3];
                this.robotItem.content = content;
            },
            downFile(file_name, dir_name){
                down_file({file_path: dir_name + '/' + file_name})
            }
        },
        watch: {
            data(newVal){
                this.robotItem = newVal;
            }
        }
    }
</script>

<style>

</style>
